import React, { useState, useEffect } from 'react';
import { Avatar } from 'antd';
import { useEmbeddedAuth } from '../../contexts/EmbeddedAuthContext';
import { getCurrentUser } from '../../services/authService';

const UserAvatar = ({ user, name, avatar, src, className, fallbackClassName, children, style, onClick, ...props }) => {
  const effectiveName = user?.name || name || '';
  const effectiveAvatar = user?.avatar || avatar || src;
  const { showLoginModal } = useEmbeddedAuth();
  const currentUser = getCurrentUser();
  
  const [imgError, setImgError] = useState(false);
  
  useEffect(() => {
    setImgError(false);
  }, [effectiveAvatar]);

  // Determine if we should show the image
  const showImage = effectiveAvatar && !imgError;

  // Generate a consistent background color based on the name
  const getBackgroundColor = (name) => {
    const colors = [
      '#F56A00', // Orange
      '#7265E6', // Purple
      '#FFBF00', // Yellow
      '#00A2AE', // Cyan
      '#1890FF', // Blue
      '#52C41A', // Green
      '#F5222D', // Red
      '#EB2F96', // Magenta
    ];
    if (!name) return colors[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash % colors.length);
    return colors[index];
  };

  const fallbackStyle = !showImage ? {
    backgroundColor: getBackgroundColor(effectiveName),
    color: '#fff',
    ...style
  } : style;

  const handleClick = (e) => {
    if (onClick) {
      // 如果传递了onClick，在执行前检查登录状态（但这取决于调用方是否已经处理了，
      // 这里作为通用组件，强制检查可能会影响不需要登录的场景。
      // 但根据用户需求，头像点击似乎都涉及跳转个人主页等需要登录的操作。
      // 鉴于这是一个通用组件，更好的做法是让调用者处理登录检查，
      // 或者我们可以只在特定的页面上下文做，但这里无法区分。
      // 不过考虑到之前的 FindFriendDetailPage 已经在外层处理了，这里也许不需要强制加？
      // 但用户选中的是头像元素，也许有些地方直接用了 UserAvatar 而没加检查。
      // 让我们看看 FindFriendDetailPage 是怎么用的：
      // onClick={() => { if (!currentUser) ... }}
      // 所以调用方已经处理了。
      // 但是 ProposalDetailPage 中：
      // onClick={handleUserClick} -> handleUserClick 中也加了检查。
      // 那么 UserAvatar 本身可能不需要修改，除非有漏网之鱼。
      // 用户提到的第一个 `div` 是 "User avatar/name link"。
      // 在 ProposalDetailPage.js 中，我已经修改了 handleUserClick。
      // 在 FindFriendDetailPage.js 中，之前也修改了。
      // 看来 UserAvatar 不需要改，改调用处即可。
      // 等等，用户给的第一个HTML片段是：
      // <div class="acss-156vebv"><span class="ant-avatar ...">...</span>...</div>
      // 这看起来像是一个列表项。
      // 如果是通用的列表项，可能在其他组件里。
      // 比如评论列表 Comments.jsx 或 ReplyList.jsx
      
      onClick(e);
    }
  };

  return (
    <Avatar
      src={showImage ? effectiveAvatar : undefined}
      className={`${className || ''} ${!showImage ? (fallbackClassName || '') : ''}`}
      style={fallbackStyle}
      onError={() => {
        setImgError(true);
        return true;
      }}
      onClick={handleClick}
      {...props}
    >
      {effectiveName ? effectiveName.charAt(0).toUpperCase() : (children || 'U')}
    </Avatar>
  );
};

export default UserAvatar;
